// Configuration for platform URLs
// These can be overridden by environment variables

// Default URLs for production
const DEFAULT_PLATFORM_URL = 'https://platform.jua.ai';

// Environment variables from Vite (defined in .env files or at build time)
export const PLATFORM_URL = import.meta.env.VITE_PLATFORM_URL || DEFAULT_PLATFORM_URL;

// Helper function to determine if we're using local development URLs
export const isUsingLocalDevelopment = (): boolean => {
  return PLATFORM_URL.includes('localhost') || PLATFORM_URL.includes('127.0.0.1');
};

// Export a function to get the platform URL with optional path
export const getPlatformUrl = (path: string = ''): string => {
  return `${PLATFORM_URL}${path}`;
};

// Helper function to get the Athena URL based on current hostname
export const getAthenaUrl = (): string => {
  const hostname = window.location.hostname;
  if (hostname === 'app.jua.ai') {
    return 'https://athena.jua.ai';
  }
  if (hostname === 'app.dev.jua.ai') {
    return 'https://athena.dev.jua.ai';
  }
  // Default to dev Athena for local development
  return 'https://athena.dev.jua.ai';
};
